import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	ellipse: {
		width           : "2.5px",
		height          : "2.5px",
		margin          : "0rem 0.5rem",
		borderRadius    : "50%",
		backgroundColor : theme.other.colors.text.secondary
	},
	statsContainer: {
		display    : "flex",
		alignItems : "center"
	},
	headerInfoContainer: {
		display      : "flex",
		alignItems   : "center",
		marginBottom : "2.5rem"
	},
	avatarListContainer: {
		margin     : "0 1rem",
		display    : "flex",
		alignItems : "center"
	},
	avatar: {
		height       : "2rem",
		width        : "2rem",
		borderRadius : "100%",
		border       : `1px solid ${ theme.other.colors.background.secondary }`,
		marginLeft   : "-0.75rem"
	},
	headerContainer: {
		marginBottom: "2rem"
	},
	titleClass: {
		fontSize: "1.75rem"
	},
	title: {
		fontSize     : "2rem",
		fontWeight   : "500",
		marginBottom : "1rem"
	},
	liveCount: {
		fontSize: "1.25rem"
	},
	fixedHeaderContainer: {
		top          : "70px",
		width        : "100%",
		zIndex       : 21,
		position     : "fixed",
		background   : theme.other.colors.background.secondary,
		height       : "110px",
		borderBottom : `1px solid ${ theme.other.colors.border.primary }`
	},
	headerContent: {
		margin: "2rem 2.5rem"
	}
} ), { name: "livePageSectionHeader" } );
